module.exports = __webpack_public_path__ + "static/media/flag-vietnam.a4f75c0f.svg";